// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1rGG5","left":"InfoRow_left__1qzC_"};